export const getContextMenuState = (state) => state.app.contextMenu;
export const getClickToAddDoorHintState = (state) => state.app.clickToAddDoorHintState;
